import { ErrorCode } from '@/shared/constant/error/ErrorCode';
import type { ErrorCodeMessageType } from '@/shared/constant/error/ErrorCodeMessageType';
import { setAccessToken } from '@/shared/constant/local-storage/access-token/AccessToken';
import { setAccessTokenInCookie } from '@/shared/util/cookie';
import { Card } from 'aui';
import type { CSSProperties } from 'react';
import { useEffect, useRef, useState } from 'react';

type DocsSitePreviewProps = {
  value: ErrorCodeMessageType;
};

const DocsSitePreview = (props: DocsSitePreviewProps) => {
  const { value } = props;
  const [isLoginSucceeded, setIsLoginSucceeded] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const cardStyle: CSSProperties = {
    height: 600,
    width: 440,
    border: '1px solid var(--ui-border-color-base)',
    boxShadow: '0px 0px 40px rgba(22, 14, 45, 0.02), 0px 0px 104px rgba(22, 14, 45, 0.06)',
    borderRadius: 8,
    overflow: 'hidden',
    padding: 0,
  };
  const cardBodyStyle: CSSProperties = {
    padding: '0px',
  };

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.data?.type === 'HANDLE_SUCCEEDED') {
        const { accessToken } = event.data.payload;
        if (accessToken) {
          setIsLoginSucceeded(true);
          setAccessToken(accessToken);
          setAccessTokenInCookie(accessToken);
          const pathname = window.location.pathname;
          window.location.href = pathname.replace('/preview', '') || '/';
        }
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if (isLoginSucceeded || value.errorCode !== ErrorCode.NotExisted) {
    return null;
  }

  return (
    <Card bordered={false} style={cardStyle} bodyStyle={cardBodyStyle}>
      <div style={{ height: '600px', overflow: 'hidden' }}>
        <iframe
          title="clone"
          ref={iframeRef}
          className="h-full w-full"
          src={`${value.extra?.appWebUrl ?? ''}/online-share/login`}
          frameBorder={0}
          scrolling="no"
          sandbox="allow-scripts allow-same-origin allow-popups allow-forms allow-downloads allow-modals"
          allow="cross-origin-isolated"
        />
      </div>
    </Card>
  );
};

export default DocsSitePreview;
